export const experienceData = [
  {
    id: 'exp0',
    company: "GyanUdaan",
    role: "Founder & Lead Engineer",
    time: "Oct 2024 - Present",
    location: "Nepal",
    tech: ["React", "Supabase", "n8n", "Docker", "Coolify"],
    details: [
      "Bootstrapped an EdTech platform, achieving 40k+ Playstore downloads, 15k+ TikTok followers and 2M+ organic views via content strategy.",
      "Architected a full-stack ecosystem (Mobile App, Web, Admin) using React, Supabase, and offline-first logic.",
      "Engineered automated AI content pipelines using n8n for news scraping, summarization, and audio generation.",
      "Managed self-hosted DevOps infrastructure on VPS using Docker and Coolify for cost-effective scaling."
    ]
  },
  {
    id: 'exp1',
    company: "Freelance",
    role: "Freelance Fullstack Developer",
    time: "2024 - 2025",
    location: "Nepal",
    tech: ["Android", "Java", "React", "Node.js"],
    details: [
      "Built the Community-Based Flood Early Warning System (CBFEWS) mobile app for ICIMOD, delivering real-time flood alerts to at-risk communities.",
      "Developed the LML Inventory & Billing System for ICIMOD, streamlining stock management, billing and invoicing workflows.",
      "Built the Shahu Automobiles web platform (Suzuki dealership) to showcase vehicle models and drive customer enquiries."
    ]
  },
  {
    id: 'exp2',
    company: "Anand Marketing Tech",
    role: "Lead Fullstack Developer",
    time: "May 2025 - July 2025",
    location: "Nepal",
    tech: ["React", "Node.js", "Supabase", "n8n"],
    details: [
      "Led end-to-end development of client-facing web applications using React, Node.js, and Supabase for international SMEs.",
      "Acted as primary technical contact, translating business needs into scalable solutions.",
      "Managed and mentored developers/interns, establishing Git workflows and sprint planning.",
      "Implemented automation workflows with n8n to streamline project delivery."
    ]
  },
  {
    id: 'exp3',
    company: "Brane Enterprises",
    role: "Backend Developer",
    time: "Jan 2023 - Oct 2024",
    location: "India",
    tech: ["Spring Boot", "PostgreSQL", "Jenkins", "Docker"],
    details: [
      "Built high-performance REST APIs using Spring Boot and PostgreSQL for a NoCode/LowCode platform.",
      "Designed CI/CD pipelines with Jenkins, Docker, and Cypress, improving release reliability.",
      "Automated Jira-triggered pipelines and testing workflows to reduce manual overhead.",
      "Wrote unit and integration tests for microservices architecture."
    ]
  },
  {
    id: 'exp4',
    company: "HighRadius Corp",
    role: "Fullstack Developer",
    time: "Jul 2022 - Dec 2022",
    location: "India",
    tech: ["ExtJS", "Spring Framework", "Java"],
    details: [
      "Developed enterprise features for financial systems using ExtJS and Spring Framework.",
      "Collaborated with cross-functional teams to deliver product enhancements for the Deduction Management system."
    ]
  }
];